module.exports = function getResource(label) {
    let resources = { qty: 'Quantité' };
    return resources[label];
};
